module.exports = __webpack_public_path__ + "fonts/Poppins-Regular.8081832.ttf";